import React,{ useState,useEffect } from "react";
import './styles.scss';
import { Container, Row, Col, Form, Button,Nav,ListGroup,ListGroupItem,Card,Table} from "react-bootstrap";
import DatePicker from "react-datepicker";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getcommentsvendeur} from "../../../actions/user";
import "react-datepicker/dist/react-datepicker.css";
import { BiMap,BiShoppingBag,BiUserCircle,BiHistory } from 'react-icons/bi';
import { defaultimg } from "../../../assets/images";
import { MenuVendeur } from "../../../components";
import moment from 'moment'


const Page = () => {
    const dispatch = useDispatch();
    const { user } = useSelector(state => state.user)
    const { comments } = useSelector(state => state.restaurent)
    const [startDate, setStartDate] = useState(new Date());
    const [filtres,setFiltres]=useState([]);
    const [order, setOrder] = useState('')
    const [rubrique, setRubrique] = useState('')
    const [date, setDate] = useState('')
    const [counter, setCounter] = useState('')
    const history = useHistory();


    useEffect(() => {
        dispatch(getcommentsvendeur(user.user_id,user.api_token,{}));
    }, []);

     useEffect(() => {
   if(counter){
      setFormFiltre()
   }
    
}, [counter]);


   
    function gotoCmd(item) {
       history.push(`/boutique/produit/${item?.product_name}/${item?.product_id}`);
     }


  const HandleFiltre =  (slug,type,e) => {
      
       e.preventDefault();
          switch(type){
             case 'date':

                setDate(slug)
                setCounter(1)

             break;

             case 'rubrique':

                 setRubrique(slug)
                 setCounter(1)
             break;
            case 'order':

                 setOrder(slug)
                 setCounter(1)
             break;

          }

        
            
 
    }

        const  setFormFiltre = async () => {
      let params ={filtre:'1'}


      if(rubrique){
          params.rubrique=rubrique
      }

      if(order){
        
        params.order=order

      }
      if(date){
         
         params.date=date
      }
  
  
     dispatch(getcommentsvendeur(user.user_id,user.api_token,params));
     setCounter('')

    }

    
    return (
        <div className="mescommandes register listproducts bg778635 " >
            <Container>
                <Row>
            <Col  className="text-center mx-auto my-5 froweb98"  lg="3">

               <MenuVendeur slug='commentaires' />
               
            </Col>
              
                    <Col  className="text-center mx-auto my-5 menudashright"  >

     
                            <h3 className="mb-4" ><img src="/images/venico7.png" style={{width: '38px'}} />Avis et commentaires</h3>
                             <br/> 
 
            
 

                    <form className="mb-5">
                      
                          <Row className="mb-3"  >

                          <div className='tavbleweb'>

                            <Table responsive >
                          <thead>
                            <tr>
                             
                                <th>Patient</th>
                              
                                <th  >Note </th>
                                <th  >Commentaires</th>
                         
                            

                             
                            </tr>
                          </thead>
                        <tbody>
                             {comments?.map((item) => (
                            <tr>
                             
                              <td>{item.guest_name}</td>
                             
                              <td>   
                              <div className="form-group form-group__rating">
                                                    
                                                    <div className="br-wrapper br-theme-fontawesome-stars">

                                                  <div className="br-widget">
                                                    <a data-rating-value="1" data-rating-text="1" className={(item.note>0 ? 'br-selected br-current' : '')}>
                                                    </a><a  data-rating-value="2" data-rating-text="2" className={(item.note>1 ? 'br-selected br-current' : '')}>
                                                    </a><a  data-rating-value="3" data-rating-text="3" className={(item.note>2 ? 'br-selected br-current' : '')}>
                                                    </a><a  data-rating-value="4" data-rating-text="4" className={(item.note>3 ? 'br-selected br-current' : '')}>
                                                    </a><a data-rating-value="5" data-rating-text="5" className={(item.note>4 ? 'br-selected br-current' : '')}>
                                                    </a>
                                                    </div>
                                  
                                                    </div>
                               </div>
                               </td>
                              <td>
                                 <span className='badge alert-success'>{item.comment}</span>
                              </td>
                             
                   
                            </tr> 

                            ))}
                               
                          
                          

                          </tbody>
                        </Table>

 
                          </div>
                           
                          


                        <div className='tavblemob'>
                         {comments?.map((item) => (
                              <div className='items'>
                              <a  href='javascript:void(0)'   >

                                <div className='rowitmtop'>
                                   
                                   <span>Réf : {item.sku}</span>
                                </div>

                                <div className='process-item'>

                                    <strong>{item.product_name}</strong>
                                    <div className='rowsitm'>
                                     
                                       <div> 

                                        <div className="form-group form-group__rating">
                                               
                                                                         <div className="br-wrapper br-theme-fontawesome-stars">

                                                  <div className="br-widget">
                                                    <a data-rating-value="1" data-rating-text="1" className={(item.note>0 ? 'br-selected br-current' : '')}>
                                                    </a><a  data-rating-value="2" data-rating-text="2" className={(item.note>1 ? 'br-selected br-current' : '')}>
                                                    </a><a  data-rating-value="3" data-rating-text="3" className={(item.note>2 ? 'br-selected br-current' : '')}>
                                                    </a><a  data-rating-value="4" data-rating-text="4" className={(item.note>3 ? 'br-selected br-current' : '')}>
                                                    </a><a data-rating-value="5" data-rating-text="5" className={(item.note>4 ? 'br-selected br-current' : '')}>
                                                    </a>
                                                    </div>
                                  
                                                    </div>
                                                    
                                          </div>

                                        </div>
                                       <div><span className='badge alert-success'>{item.nombreproduct} commentaire(s)</span></div>
                                       <a href='javascript:void(0)' onClick={()=>gotoCmd(item)}>Voir produit</a>
                                    </div>

                                 </div>
                                </a>
                              </div>
                              ))}

                            
 

 
                        </div> 

                        <br/> <br/>
 
                           

                          </Row>

                    </form>
                        
                         

                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Page;